<template>
  <div class="warning">
    <Icon icon="error" />
    <div>
      <h3>{{ $t(props.heading) }}</h3>
      <p v-if="props.subheading">
        {{ $t(props.subheading) }}
        <SmartFaqLink
          v-if="props.faqLink"
          :link="props.faqLink"
          title="MFA_REQUIRED.LEARN_MORE"
          hide-icon
        />
      </p>
      <div
        v-if="props.primaryActionText || props.secondaryActionText"
        class="actions"
      >
        <button
          v-if="props.primaryActionText"
          v-tooltip="{
            content: $t(props.primaryActionDisabledText || ''),
            hideOnTargetClick: false,
          }"
          :disabled="!!props.primaryActionDisabledText"
          class="btn btn-ghost"
          @click="emits('onPrimaryAction')"
        >
          {{ $t(props.primaryActionText) }}
        </button>
        <button
          v-if="props.secondaryActionText"
          class="link-main"
          @click="emits('onSecondaryAction')"
        >
          {{ $t(props.secondaryActionText) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SmartFaqLink as SmartFaqLinkType } from '@/smartFaq/smartFaqLinks';
import SmartFaqLink from '@/helpLink/SmartFaqLink.vue';
import { defineProps } from 'vue';

const props = defineProps<{
  heading: string;
  subheading?: string;
  primaryActionText?: string;
  primaryActionDisabledText?: string;
  secondaryActionText?: string;
  faqLink?: SmartFaqLinkType;
}>();

const emits = defineEmits(['onPrimaryAction', 'onSecondaryAction']);
</script>

<style lang="scss" scoped>
@import 'src/scss/constants';
@import 'src/scss/styleguide/colors';

.warning {
  display: flex;
  align-items: center;
  padding: 16px;
  margin: 0;
  border-radius: $border-radius-medium;
  background-color: $pa-color-yellow-light;

  .icon {
    margin: 0 8px auto 0;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  button {
    font-weight: normal;
    border-width: 1px;

    &.btn-ghost {
      padding: 12px 24px;
    }

    &:disabled {
      opacity: 0.6;
    }
  }

  a {
    font-weight: normal;
    text-decoration: underline;
    display: inline-block;
  }

  button,
  a {
    color: #3b3007;
    border-color: #3b3007;
  }

  h3 {
    margin: 0;
    line-height: 24px;
  }

  p {
    margin: 4px 0 0 0;
  }

  .actions {
    display: flex;
    gap: 16px;
    margin-top: 16px;
  }
}
</style>
